// extracted by mini-css-extract-plugin
export default {"button":"_2wZH1","disabled":"_1D52u","mobile-button":"_1zljM","mobileButton":"_1zljM"};